var _path, _path2, _path3, _line, _line2, _line3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDetails(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 31,
    viewBox: "0 0 38 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.76758 6.45003C1.76758 6.45003 4.12879 8.87489 4.19174 8.87489C4.25469 8.87489 10.6877 2.37891 10.6877 2.37891",
    stroke: "currentColor",
    strokeWidth: 3.09635,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.76758 16.3602C1.76758 16.3602 4.12879 18.785 4.19174 18.785C4.25469 18.785 10.6877 12.2891 10.6877 12.2891",
    stroke: "currentColor",
    strokeWidth: 3.09635,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.76758 26.2703C1.76758 26.2703 4.12879 28.6952 4.19174 28.6952C4.25469 28.6952 10.6877 22.1992 10.6877 22.1992",
    stroke: "currentColor",
    strokeWidth: 3.09635,
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16.3828,
    y1: 6.55372,
    x2: 34.7311,
    y2: 6.55372,
    stroke: "currentColor",
    strokeWidth: 4.64452,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 16.3828,
    y1: 16.4639,
    x2: 34.7311,
    y2: 16.4639,
    stroke: "currentColor",
    strokeWidth: 4.64452,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 16.3828,
    y1: 26.374,
    x2: 34.7311,
    y2: 26.374,
    stroke: "currentColor",
    strokeWidth: 4.64452,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetails);
export default __webpack_public_path__ + "static/media/details.ff2dd717847c2e105c9bfc9fe20cbf61.svg";
export { ForwardRef as ReactComponent };